import React from "react";
import { GAME_DESCRIPTION } from "../utils/constants";
import { useNavigate } from "react-router-dom";

export default function Intro() {
  const navigate = useNavigate();
  return (
    <section className="intro-container">
      <div className="wrapper">
        <p>{GAME_DESCRIPTION}</p>
        <button
          onClick={() => {
            navigate("/");
          }}
        >
          Start
        </button>
      </div>
    </section>
  );
}
